// Copyright (c) Bentley Systems
type DownloadFileProps = {
  readonly apiDefinition: () => Promise<Blob | undefined>;
  readonly preDownloading: () => void;
  readonly postDownloading: () => void;
  readonly onError: (
    responseStatusCode: number,
    activityId: string | undefined,
  ) => void;
  readonly getSanitizedFileName: () => string;
};

type DownloadedFileInfo = {
  readonly download: () => Promise<void>;
};

export const useDownloadFile = ({
  apiDefinition,
  preDownloading,
  postDownloading,
  onError,
  getSanitizedFileName,
}: DownloadFileProps): DownloadedFileInfo => {
  const download = async () => {
    try {
      preDownloading();
      const blob = await apiDefinition();
      if (blob !== undefined) {
        const fileURL = URL.createObjectURL(blob);

        const fileLink = document.createElement("a");
        fileLink.setAttribute('href', fileURL);
        
        const sanitizedFileName = getSanitizedFileName();
        fileLink.setAttribute("download", sanitizedFileName);
        document.body.appendChild(fileLink);
        fileLink.click();

        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);

        postDownloading();
      }else{
        postDownloading();
      }
    } catch {
      onError(0, undefined);
    }
  };

  return { download };
};